import { get, values, orderBy } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getCustomList = get('customList');

export const getAll = createSelector(getCustomList, get('all'));

export const getAllValues = createSelector(getAll, values);

export const getOrderedCustomLists = createSelector(
  getAllValues,
  orderBy('position', 'asc')
);

export const getIsFetching = createSelector(getCustomList, get('fetching'));
export const getIsFetched = createSelector(getCustomList, get('fetched'));
export const getFetchingError = createSelector(
  getCustomList,
  get('fetchingError')
);

export const getOrder = createSelector(getCustomList, get('order'));
